import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-competency-dialog',
  templateUrl: './view-competency-dialog.component.html',
  styleUrls: ['./view-competency-dialog.component.css']
})
export class ViewCompetencyDialogComponent implements OnInit {
  competencies: any[] = [];

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token') 
    })
  };

  private apiUrl = environment.apiUrl; // Your API base URL
  

  constructor(
    private dialogRef: MatDialogRef<ViewCompetencyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private dialog: MatDialog,
    private toastr: ToastrService 
  ) {}

  ngOnInit(): void {
    this.fetchCompetencyData();
  }

  // Fetch competency data from the API
  fetchCompetencyData(): void {
    this.http.get<any>(`${this.apiUrl}Competency/GetNoCompetencyEmployeeIds?search=%20&from=0&size=20`, this.httpOptions)
      .subscribe((response) => {
        if (response.data) {
          this.competencies = response.data.map(item => ({
            competency: item.competency,
            subCompetency: item.subCompetency,
            assigned: item.assigned,
            requested: item.requested,
            comments: item.comments,
            employeeCompetencyRequestedId: item.employeeCompetencyRequestedId,
            employeeId: item.employeeId,
            requestedCompetencyId: item.requestedCompetencyId,
            requestedCompetencyName: item.requestedCompetencyName,
            requestedSubCompetencyId: item.requestedSubCompetencyId,
            requestedSubCompetencyName: item.requestedSubCompetencyName,
            assignedCompetencyId: item.assignedCompetencyId,
            assignedCompetencyName: item.assignedCompetencyName,
            assignedSubCompetencyId: item.assignedSubCompetencyId,
            assignedSubCompetencyName: item.assignedSubCompetencyName,
            requestedDate: item.requestedDate,
            coeName: item.coeName,
            subspocNames: item.subspocNames,
            skills:item.Skills
          }));
        }
      }, error => {
        console.error('Error fetching competency data:', error);
      });
  }

  // Open the confirmation dialog

  // Open the confirmation dialog for either Approve or Reject
  openConfirmDialog(action: string, requestData: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '493px',
      height: '240px',
      data: { action, requestData }  // Make sure this is not null or undefined
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (action === 'accept') {          
          this.toastr.success('Request Accepted');
        } else if (action === 'decline') {          
          this.toastr.error('Request Declined');  
        }
        this.dialogRef.close(true);
      }
    });
  }

  // Close the dialog
  onCancel(): void {
    this.dialogRef.close();
  }
}
